import React from 'react';
import ReactPlayer from 'react-player';
import './VideoShowStyle.css';

const ResponsivePlayer = ({ videoUrl }) => {
  let a;
  /* eslint-disable jsx-a11y/media-has-caption */
  return (
    <div data-aos="fade-right" className="player-wrapper">
      <video src={videoUrl} controls />
    </div>
  );
};

export default ResponsivePlayer;
